import { Card, Classes, Colors, H1 } from "@blueprintjs/core";
import ReactEcharts from "echarts-for-react";
import upperCase from "lodash/upperCase";
import React from "react";

const LoadingCard = () => {
  return (
    <Card style={{ height: "100%" }}>
      <H1 className={Classes.SKELETON}>loading..</H1>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
      <p className={Classes.SKELETON}>loading..</p>
    </Card>
  );
};

const EmptyCard = () => {
  return (
    <Card style={{ height: "100%" }}>
      <H1>Data Tidak ada</H1>
      <p>Maaf data yang dicari tidak ditemukan</p>
    </Card>
  );
};

// render echarts option.
export default function PBar({ loading, data, title, list, subText }) {
  if (loading) {
    return <LoadingCard />;
  }

  if (data) {
    const { __typename, ...result } = data;

    const isFuckingNull = Object.values(result).every((d) => d === null);

    const listOperator = list || Object.keys(result).map((m) => upperCase(m));

    const hasil = {
      color: [Colors.INDIGO1],
      title: {
        text: `${title}`,
        subtext: `${subText || "Belum di set"}`,
        subtextStyle: {
          fontSize: 10,
        },
      },
      legend: {},
      tooltip: {},
      xAxis: {
        type: "category",
        data: listOperator,
      },
      yAxis: { type: "value" },
      toolbox: {
        show: true,
        feature: { saveAsImage: { type: "svg", title: "Unduh Chart" } },
      },
      series: [
        {
          data: Object.values(result).map((d) => (d === null ? 0 : d)),
          type: "bar",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(220, 220, 220, 0.8)",
          },
          label: {
            show: true,
            position: "top",
          },
        },
      ],
    };
    return (
      <React.Fragment>
        {isFuckingNull ? (
          <EmptyCard />
        ) : (
          <Card style={{ height: "100%" }}>
            <ReactEcharts
              style={{ height: "100%", width: "100%" }}
              option={hasil}
              opts={{ renderer: "svg" }}
            />
          </Card>
        )}
      </React.Fragment>
    );
  }
}
